module.exports = __webpack_public_path__ + "img/cover.8d872209.jpg";